export const USER_ADDONS = {
  ALL: 'All',
  LIVESTREAM: 'Livestream',
  STATS: 'Stats',
  ENGAGE: 'Engage',
  FANS: 'Fans',
  STUDIO: 'Studio',
  // A club reading the federation competition its team is paired into (shown as "Stats").
  VIEW_STATS: 'ViewStats',
}
